export default "__VITE_ASSET__brjGMAVm__"